import gql from 'graphql-tag';
import client from '../../client';
export const VERIFY_STRIPE_PAYMENT_METHOD = gql `
  mutation verifyPaymentMethod($input: PaymentInput) {
    verifyPaymentMethod(input: $input) @rest(type: "VerifyPaymentMethod", path: "payments/verify", method: "POST") {
      data {
        createdAt
        customerId
        default
        id
        paymentMethod
        updatedAt
        userId
      }
    }
  }
`;
export const verifyStripePaymentMethod = (userId, setupIntentId) => {
    return client.mutate({
        mutation: VERIFY_STRIPE_PAYMENT_METHOD,
        variables: {
            input: {
                userId,
                setupIntentId,
            },
        },
    });
};
export default verifyStripePaymentMethod;
